/**
 * exit Receipt
 */

// React
import React, { useEffect, useState } from 'react';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';
import jMoment from 'moment-jalaali';
import Barcode from 'react-barcode';

// Type
import { Props } from '../interfaces';
import { formaterPhoneNumber, translate } from '../../../utils/helpers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../../utils/handleError';
import { Typography } from '@material-ui/core';
import getLogo from 'client-sdk/src/partners/getLogo';
import RonadIcons from '../../../components/iconComponent';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function ExitReceipt(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const [logo, setLogo] = useState<string>("")

  const getOrderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const { id } = props.match.params;
    getOrderWithId(id);
  }, []);

  useEffect(() => {
    if (order.id) {
      getLogoFile()
    }
  }, [order]);

  useEffect(() => {
    if (order.id && logo) {
      window.print();
    }
  }, [logo])

  const getLogoFile = async () => {
    // const response = await partnersRepository.getPartnerLogo({ payload: { id: props.data.id } })
    // let base64ImageString = Buffer.from(response.data, 'binary').toString('base64')
    // setLogo(base64ImageString)
    getLogo(order?.partnerId)
      .then(res => {
        if (res.ok) {
          return res.blob()
        } else {
          throw new Error("error");
        }
      })
      .then(blob => {
        if (blob.size > 0) {
          setLogo(URL.createObjectURL(blob))
        } else {
          setLogo("NONE")
        }
      }).catch(err => {
        setLogo("NONE")
      })
  }

  return (
    <WrapperReceipt className={classes.root}>
      <div className="page">
        <div className="pageInner">
          <main>
            <table>
              <tbody>
                <tr>
                  <td
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{ width: '100%', textAlign: 'center' }}
                      className="text-bold"
                    >
                      {/* {order?.partnerId === 9 ? (
                        <img
                          className="partnerIcon"
                          src="/basalaam.png"
                          alt="باسلام"
                        />
                      ) : order?.partnerId === 10 ? (
                        <img
                          className="partnerIcon"
                          src="/abzaarmart.png"
                          alt="ابزارمارت"
                        />
                      ) : order?.partnerId === 53 ? (
                        <img
                          className="partnerIcon"
                          src="/deniran.png"
                          alt="دنیران"
                        />
                      ) : (
                        order?.partnerName
                      )} */}
                      {(logo && logo !== "NONE") ? <img width="100" height="100" src={logo} alt="logo" /> : order?.partnerName}
                    </div>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                      <span>{'کد پیگیری : '}</span>{' '}
                      <span>{order.trackingCode}</span>
                    </div>
                  </td>
                  <td style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Barcode
                      fontSize={12}
                      value={order.parentId ? order.parentId : order.id}
                      height={'30px'}
                      background="White"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="text-bold">
                    {/* <span style={{ marginLeft: '4px' }}>
                    </span> */}
                    <span style={{ marginLeft: '1px', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                      <RonadIcons name='user' size={.7} />
                      {'گیرنده: '}
                      <span style={{ marginRight: '2px' }}>
                        {order?.customerName?.substring(0, 25)}
                      </span>
                    </span>
                  </td>
                  <td className="text-bold">
                    <span style={{ marginLeft: '1px', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                      <RonadIcons name='mapMarker' size={.7} />
                      <span style={{ marginRight: '2px' }}>
                        {order?.customerProvince} - {order?.customerCity}
                      </span>
                    </span>
                    {order.deliveryType == 'CHAPAR' && (
                      <span style={{ marginRight: '30px' }}>
                        <Typography variant='subtitle2'>چاپار</Typography>
                      </span>
                    )}

                  </td>
                </tr>
                <tr>
                  <td className="text-bold">
                    <span style={{ marginLeft: '1px', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                      <RonadIcons name="calendar" size={.7} />
                      <span style={{ marginRight: '2px', marginLeft: '2px', direction: 'ltr' }}>
                        {order?.deliveryDate &&
                          jMoment(order.deliveryDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYY/jMM/jDD dddd')}
                      </span>
                      <span
                        style={{
                          borderRight: '2px solid gray',
                          paddingRight: '2px',
                          margin: '0 2px',
                        }}
                      >
                        <span style={{ direction: 'ltr' }}>
                          {order?.deliveryEndTime &&
                            jMoment(order.deliveryEndTime, 'HH:mm:ss')
                              .locale('fa')
                              .format('HH:mm')}
                          {' - '}
                          {order?.deliveryStartTime &&
                            jMoment(order.deliveryStartTime, 'HH:mm:ss')
                              .locale('fa')
                              .format('HH:mm')}{' '}
                        </span>

                      </span>
                    </span>
                  </td>
                  <td className="text-bold">
                    <span style={{ marginLeft: '1px', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                      <RonadIcons name='creditCard' size={.7} />
                      <span style={{ marginRight: '2px', direction: 'ltr' }}>
                        {' پرداخت '} {translate(order?.paymentType, 'cod')}
                      </span>
                      {order?.paymentType != 'ONLINE' && (
                        <span style={{ marginRight: '30px' }} >{order.codValue?.toLocaleString()} </span>
                      )
                      }
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ width: '100%', padding: '5px 4px', height: '80px' }}
                    className="text-bold"
                  >

                    <span style={{ marginLeft: '10px' }}>
                      {'فرستنده: '}
                      <span>{order?.partnerName}</span>
                      <span style={{ marginRight: '10px' }}>{'آدرس: '}</span>
                      <span style={{ marginLeft: '5px' }}>
                        {order?.isUsingPartnerAddress
                          ? order?.partnerAddress
                          : order?.fulfillmentWarehouseAddress}


                      </span>
                      <span
                        style={{
                          borderRight: '2px solid gray',
                          paddingRight: '5px',
                          margin: '0 5px',
                        }}
                      >
                        {'کد پستی: '}
                      </span>
                      <span>
                        {order?.isUsingPartnerAddress
                          ? order?.partnerZipCode
                          : order?.fulfillmentWarehouseZipCode}
                      </span>
                      <span style={{ marginRight: '10px' }}>{'تلفن: '}</span>
                      <span style={{ direction: 'ltr', display: 'inline-block' }}>
                        {formaterPhoneNumber(order?.partnerPhoneNumber)}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ width: '100%', padding: '5px 4px', height: '80px' }}
                    className="text-bold"
                  >

                    <span style={{ marginLeft: '10px' }}>
                      {'آدرس گیرنده: '}
                      <span>{order?.customerAddress}</span>
                      <span
                        style={{
                          borderRight: '2px solid gray',
                          paddingRight: '5px',
                          margin: '0 5px',
                        }}
                      >
                        {'کد پستی: '}
                      </span>
                      <span>{order?.customerZipCode}</span>
                      <span
                        style={{
                          borderRight: '2px solid gray',
                          paddingRight: '5px',
                          margin: '0 5px',
                        }}
                      >
                        {'شماره همراه: '}
                      </span>
                      <span>{formaterPhoneNumber(order?.customerMobileNumber)}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '100%' }}>
                    <div className="footer">
                      <img src="/footer2.png" alt="ronad" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </div>
      </div>
    </WrapperReceipt >
  );
}

export default ExitReceipt;
